const REQUIRED_TOKEN_PATTERN = /\{\{\s*([a-zA-Z][\w]*)\s*\}\}/g;

function uniqueStable(values: string[]): string[] {
  return [...new Set(values)];
}

export function extractRequiredVariableTokens(source: string): string[] {
  const matches = [...source.matchAll(REQUIRED_TOKEN_PATTERN)].map((match) => match[1]);
  return uniqueStable(matches);
}

export interface RequiredTokenValidationResult {
  valid: boolean;
  requiredTokens: string[];
  nextTokens: string[];
  missingTokens: string[];
}

export function validateRequiredVariablePreservation(
  originalValue: string,
  nextValue: string
): RequiredTokenValidationResult {
  const requiredTokens = extractRequiredVariableTokens(originalValue);
  const nextTokens = extractRequiredVariableTokens(nextValue);
  const nextTokenSet = new Set(nextTokens);
  const missingTokens = requiredTokens.filter((token) => !nextTokenSet.has(token));

  return {
    valid: missingTokens.length === 0,
    requiredTokens,
    nextTokens,
    missingTokens,
  };
}
